/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import LocationOn from "@material-ui/icons/LocationOn";
import Notifications from "@material-ui/icons/Notifications";
import Unarchive from "@material-ui/icons/Unarchive";
import Language from "@material-ui/icons/Language";
// core components/views for Admin layout
// import DashboardPage from "views/Dashboard/Dashboard.js";
// import UserProfile from "views/UserProfile/UserProfile.js";
// import TableList from "views/TableList/TableList.js";
// import Typography from "views/Typography/Typography.js";
// import Icons from "views/Icons/Icons.js";
// import Maps from "views/Maps/Maps.js";
// import NotificationsPage from "views/Notifications/Notifications.js";
// import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.js";
// core components/views for RTL layout
// import RTLPage from "views/RTLPage/RTLPage.js";
import LoginPage from "containers/LoginPage/Loadable";
export const NoActiveModuleRoutes = [
  // {
  //   path:'/DataAnalytics',
  //   name:'Data Analytics'
  // },
  // {
  //   path:'/DataFetch/fetchDetail',
  //   name:'Data Fetch'
  // },
  // {
  //   path:'/gstr9/upload',
  //   name:'GSTR-9'
  // },
  {
    path: "/analyticsGSRT1VS3B",
    name: "Analytics",
  },
];
export const AnalyticsModuleRoutes = [
  {
    path: "/analyticsGSTR1VS3B",
    name: "GSTR-1 vs GSTR-3B",
  },
  {
    path: "/analyticsGSTR3BVS2A",
    name: "GSTR-3B vs GSTR-2A/2B",
  },
  {
    path: "/returnFilling",
    name: "Return Filing Analysis",
  },
  {
    path: "/ewayBillReco",
    name: "E-waybill Reconciliation",
  },

  {
    path: "/rcmLiability",
    name: "RCM on Inward supplies",
  },

  {
    path: "/turnoverAnalysis",
    name: "Turnover Analysis",
  },

  {
    path: "/hsnAnalysis",
    name: "HSN Analysis Outward",
  },
  {
    path: "/hsnAnalysisInward",
    name: "HSN Analysis Inward",
  },
  {
    path: "/taxDischarged",
    name: "Tax Discharged Analysis",
  },
  {
    path: "/itcAnalysis",
    name: "ITC Analysis",
  },
  {
    path: "/ledgerAnalysis",
    name: "Ledger Balance Analysis",
  },
  {
    path: "/creditAnalysis",
    name: "Credit Note Analysis",
  },
];

export const SupplierModuleRoutes = [
  {
    path: "/fetchGstnDetail",
    name: "GSTIN Validation",
  },
  {
    path: "/trackReturn",
    name: "Track Return",
  },
  {
    path: "/vendorMaster",
    name: "Vendor Master",
  },
  // {
  //   path:'/gstr9/upload',
  //   name:'GSTR-9'
  // },
];
export const AllModuleRoutes = [
  {
    path: "/eWayBill/upload",
    name: "E-Waybill",
    moduleId: 2,
  },
  {
    path: "/eInv/upload",
    name: "E-Invoice and E-Way Bill",
    moduleId: 1,
  },
  // {
  //   path: "/gstr1/upload",
  //   name: " GSTR-1",
  //   moduleId: 3,
  // },
  {
    path: "/gstr1New/upload",
    name: " GSTR-1-New",
    moduleId: 3,
  },
  {
    path: "/gstr/upload",
    name: "GSTR-2A and 2B Reconciliation",
    moduleId: 4,
  },
  {
    path: "/gstr3b/upload",
    name: "GSTR-3B",
    moduleId: 5,
  },
  {
    path: "/DataAnalytics",
    name: "Data Analytics",
    moduleId: 6,
  },
  {
    path: "/DataFetch/fetchDetail",
    name: "Data Fetch",
    moduleId: 7,
  },
  {
    path: "/gstr7/upload",
    name: "GSTR-7",
    moduleId: 11,
  },
  {
    path: "/gstr8/upload",
    name: "GSTR-8",
    moduleId: 15,
  },
  {
    path: "/gstr6/upload",
    name: "GSTR-6",
    moduleId: 13,
  },
  {
    path: "/itc04/upload",
    name: "ITC-04",
    moduleId: 12,
  },
  {
    path: "/gstr2X/prepare",
    name: "GSTR-2X",
    moduleId: 14,
  },
  // {
  //   path: "/gstr6/upload",
  //   name: "GSTR-6",
  //   moduleId: 8,
  // },
  // {
  //   path: "/itc04/upload",
  //   name: "ITC-04",
  //   moduleId: 10,
  // },

  {
    path: "/gstr9/upload",
    name: "GSTR-9 and GSTR-9C",
    moduleId: 8,
  },
  {
    path: "/analyticsGSTR1VS3B",
    name: "Analytics",
    moduleId: 9,
  },
  {
    path: "/gtaxpro_tutorial",
    name: "GtaxPro Tutorials",
    moduleId: 16,
  },
];
export const ReturnsRoutes = [
  {
    path: "/gstr1New/upload",
    name: " GSTR-1",
    moduleId: 3,
  },
  // {
  //   path: "/gstr/upload",
  //   name: "GSTR-2A and 2B Reconciliation",
  //   moduleId: 4,
  // },
  {
    path: "/gstr2a2b/upload",
    name: "GSTR-2A and 2B Reconciliation",
    moduleId: 4,
  },
  {
    path: "/gstr3b/upload",
    name: "GSTR-3B",
    moduleId: 5,
  },
  {
    path: "/gstr7/upload",
    name: "GSTR-7",
    moduleId: 11,
  },
  {
    path: "/gstr8/upload",
    name: "GSTR-8",
    moduleId: 15,
  },
  {
    path: "/gstr6/upload",
    name: "GSTR-6",
    moduleId: 13,
  },
  {
    path: "/itc04/upload",
    name: "ITC-04",
    moduleId: 12,
  },
  {
    path: "/gstr2X/prepare",
    name: "GSTR-2X",
    moduleId: 14,
  },
  {
    path: "/gstr9_new/upload",
    name: "GSTR-9 and GSTR-9C",
    moduleId: 8,
  },
  // {
  //   path: "/ims/prepare",
  //   name: "IMS",
  //   moduleId: 17,
  // },
  {
    path: "/imsreco/dataUpload",
    name: "IMS Reconciliation",
    moduleId: 17,
  },
]; 
export const NotReturnsRoutes=[
  {
    path: "/eWayBill/upload",
    name: "E-Waybill",
    moduleId: 2,
  },
  {
    path: "/ewb_reco/upload",
    name: "E-Waybill Reco",
    moduleId: 18,
  },
  {
    path: "/eInv/upload",
    name: "E-Invoice and E-Way Bill",
    moduleId: 1,
  }, 
  {
    path: "/DataAnalytics",
    name: "Data Analytics",
    moduleId: 6,
  },
  {
    path: "/DataFetch/fetchDetail",
    name: "Data Fetch",
    moduleId: 7,
  },
  {
    path: "/analyticsGSTR1VS3B",
    name: "Analytics",
    moduleId: 9,
  },
   {
     path: "/repository",
    name: "Repository",
    moduleId: 19,
  },
  {
    path: "/Notice/Notice",
    name: "Notice",
    moduleId: 20,
  },
  // ,
  // {
  //   path: "/gtaxpro_tutorial",
  //   name: "GtaxPro Tutorials",
  //   moduleId: 16,
  // },
  // {
  //   path: "/imsreco/dataUpload",
  //   name: "IMS Reconciliation",
  //   moduleId: 17,
  // },
]
export const eInvRoutes = [
  {
    path: "/eInv/upload",
    name: "Data Upload",
  },
  // {
  //   path: '/eInv/uploadb2c',
  //   name: 'B2C Data Upload',
  // },
  // {
  //   path: '/eInv/progress',
  //   name: 'Upload Progress',
  // },
  {
    path: "/eInv/processed",
    name: "E-Invoice",
  },
  {
    path: "/eInv/failed",
    name: "Failed Invoices",
  },
  {
    path: "/eInv/ewaybill",
    name: "E-Way Bill",
  },
  // {
  //   path: "/eInv/consolidate",
  //   name: "Consolidate EWB",
  // },
  // {
  //   path: '/eInv/reports',
  //   name: 'Reports',
  // },

  // {
  //   path: '/eInv/schedule/progress',
  //   name: 'Scheduler Progress',

  // },
  {
    path: "/b2c/upload", //'/eInv/b2cinvoices',
    name: "B2C Invoices",
  },
  // {
  //   path: '/eInv/invoiceDetail',
  //   name: 'Invoice Details',
  // },
  // {
  //   path: '/logout',
  //   name: 'Log Out',
  // }
  {
    path: "/eInv/download-center",
    name: "Download Center",
  },
];

export const anx1Routes = [
  {
    path: "/gstr/upload",
    name: " Data Upload",
  },
  {
    path: "/gstr/DataFetch",
    name: "Data Fetch",
  },
  {
    path: "/gstr/reconciliation",
    name: "Reconciliation",
  },
  // {
  //   path: '/gstr/fileProgress',
  //   name: 'File Progress',
  // },
  // {
  //   path: '/gstr/uploadedFiles',
  //   name: 'Prepare GSTR2A',
  // },
  // {
  //   path: '/gstr/pendingInvoices',
  //   name : 'Pending Invoices'
  // },
  // {
  //   path: '/gstr/purchaseSummary',
  //   name : 'Purchase Summary'
  // },
  // {
  //   path: '/gstr/gstr2b',
  //   name: 'GSTR2B Reconciliation',
  // },
  // {
  //   path: '/gstr/processed',
  //   name: 'Processed Invoices',
  // },
  // {
  //   path: '/gstr/failed',
  //   name: 'Failed Invoices',
  // },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  // }
];

export const ewayBillRoutes = [
  {
    path: "/eWayBill/upload",
    name: "Data Upload",
  },
  {
    path: "/eWayBill/EwayBillPartB",
    name: "E-Way Bill",
  },
  {
    path: "/eWay/EwayBillConsolidate",
    name: "Consolidate EWB",
  },
  {
    path: "/eWayBill/EwayBillGet",
    name: "E-Way Bill Data Fetch",
  },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  // }
];
export const ewayBillRecoRoutes = [
  {
    path: "/ewb_reco/upload",
    name: "Data Upload",
  },
  {
    path: "/ewb_reco/fetch",
    name: "Fetch",
  },
  {
    path: "/ewb_reco/reconcilation",
    name: "Reconciliation",
  },
];	

export const manageProfile = [
  // {
  //   path: '/eWayBill/upload',
  //   name: 'E-Waybill',
  // },
  // {
  //   path: '/gstr/upload',
  //   name: 'GSTR-2A and 2B Reconciliation',
  // },
  // {
  //   path: '/eInv/upload',
  //   name: 'E-Invoice and E-Way Bill',
  // },
  // {
  //   path: '/gstr1/upload',
  //   name: 'GSTR-1',
  // },
  // {
  //   path: '/gstr3b/upload',
  //   name: 'GSTR-3B',
  // },
  // {
  //   path: '/DataAnalytics',
  //   name: 'Data Analytics',
  // },
  // {
  //   path: '/DataFetch',
  //   name: 'Data Fetch',
  // },
  // {
  //   path: '/invoiceDetail',
  //   name: 'Invoice Details',
  // },
  // {
  //   path: '/supplierDetails',
  //   name: 'Supplier Details',
  // },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  // }
];

export const dataFetchRoutes = [
  {
    path: "/DataFetch/fetchDetail",
    name: "Data Fetch",
  },
];

export const dataFetchSubRoutes = [
  {
    path: "/DataFetch/CashITCBalance",
    name: "Cash ITC Balance",
  },
  {
    path: "/DataFetch/CashITCLedger",
    name: "ITC/Cash Ledger",
  },
];

export const gstr9Routes = [
  {
    path: "/gstr9/upload",
    name: "Data Upload",
  },

  {
    path: "/gstr9/uploadedDate",
    name: "Prepare GSTR-9",
  },
  {
    path: "/gstr9/saveGstr9",
    name: "Save GSTR-9",
  },
];
export const gstr9CRoutes = [
  {
    path: "/gstr9c/prepareGstr9c",
    // path:'/gstr9/saveGstr9',
    name: "Prepare GSTR-9C",
  },
  {
    path: "/gstr9c/saveGstr9c",
    name: "Save GSTR-9C",
  },
];

export const gstrRoutes = [
  {
    path: "/gstr1/upload",
    name: "Data Upload",
  },
  // {
  //   path: '/gstr1/uploadProgress',
  //   name: 'Uploaded Progress',
  // },
  {
    path: "/gstr1/uploadedDate",
    name: "Prepare GSTR-1",
  },
  {
    path: "/gstr1/saveGstr1",
    name: "Save GSTR-1",
  },
  // {
  //   path: '/gstr1/summary',
  //   name: 'Summary',
  // },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  // }
];
export const gstr1NewRoutes = [
  {
    path: "/gstr1New/upload",
    name: "Data Upload",
  },
  {
    path: "/gstr1New/viewData",
    name: "View Data",
  },
  {
    path: '/gstr1New/fetch&Reconcile',
    name: 'Fetch & Reconcile',
  },
  {
    path: "/gstr1New/save",
    name: "Save",
  },
  {
    path: "/gstr1New/file",
    name: "File",
  },
  // {
  //   path: '/gstr1/summary',
  //   name: 'Summary',
  // },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  // }
];

export const gstr7Routes = [
  {
    path: "/gstr7/upload",
    name: "Data Upload",
  },
  {
    path: "/gstr7/summary",
    name: "Summary",
  },
  {
    path: "/gstr7/cash",
    name: "Cash Balance",
  },
  {
    path: "/gstr7/file",
    name: "File GSTR-7",
  },
];

export const gstr8Routes = [
  {
    path: "/gstr8/upload",
    name: "Data Upload",
  },
  {
    path: "/gstr8/prepare",
    name: "Prepare & Save",
  },
  {
    path: "/gstr8/cash",
    name: "Cash Balance",
  },
  {
    path: "/gstr8/file",
    name: "File GSTR-8",
  },
];


export const gstr6Routes = [
  {
    path: "/gstr6/upload",
    name: "Data Upload",
  },
  {
    path: "/gstr6/view",
    name: "View",
  },
  {
    path: "/gstr6/gstr6a",
    name: "GSTR-6A",
  },
  {
    path: "/gstr6/ISDdetails",
    name: "ISD Details",
  },
  {
    path: "/gstr6/gstr6",
    name: "GSTR-6",
  },
];
export const itc04Routes = [
  {
    path: "/itc04/upload",
    name: "Data Upload",
  },
  {
    path: "/itc04/view",
    name: "View Data",
  },
  {
    path: "/itc04/Prepare",
    name: "Prepare Return",
  },
  {
    path: "/itc04/File",
    name: "File Return",
  },
  {
    path: "/itc04/Analytics",
    name: "Analytics",
  },
];
export const gstr2XRoutes = [
  {
    path: "/gstr2X/prepare",
    name: "Prepare Data",
  },
  {
    path: "/gstr2X/save",
    name: "Save Data",
  },
  {
    path: "/gstr2X/file",
    name: "File GSTR-2X",
  },
];
export const gstr3bRoutes = [
  {
    path: "/gstr3b/upload",
    name: "Prepare",
  },
  // {
  //   path: '/gstr3b/fileProgress',
  //   name: 'Uploaded Progress',
  // },
  {
    path: "/gstr3b/progress",
    name: "View",
  },
  {
    path: "/gstr3b/save",
    name: "Save",
  },

  // {
  //   path: '/gstr3b/summary',
  //   name: 'Summary',
  // },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  // }
];

export const superAdminRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    activeList:["/dashboard"]
  },
  {
    path: "/userManagement",
    name: "User Management",
    activeList:["/userManagement","/userModules","/profileManagement","/useractivity"]
  },
  // {
  //   path: '/manageModule',
  //   name: 'Manage Modules'
  // },
  {
    path: "/manageCompanies",
    name: "Manage Entity",
    activeList:["/manageCompanies"]
  },
  {
    path: "/managePartner",
    name: "Manage Partner",
    activeList:["/managePartner"]
  },
  {
    path: "/manageGroup",
    name: "Manage Group",
    activeList:["/manageGroup"]
  },
  {
    path: "/managePassInv",
    name: "Manage Pass Env",
    activeList:["/managePassInv"]
  },
  {
    path: "#",
    name: "Report",
    activeList: ['/report', '/gstinreport', '/apireport'],
    subRoutes: [
      { name: 'Module Report', path: '/report' },
      { name: 'GSTIN Report', path: '/gstinreport' },
      { name: 'API Report', path: '/apireport' }
    ] 
  },
  // {
  //   path: "/gstinreport",
  //   name: "GSTIN Report",
  //   activeList:["/gstinreport"]
  // },
  // {
  //   path: "/apireport",
  //   name: "API Report",
  //   activeList:["/apireport"]
  // },
  {
    path: "/setting",
    name: "Settings",
    activeList:["/setting"]
  },
  // {
  //   path: '/managePincode',
  //   name: 'Manage Pin Code'
  // },
  // {
  //   path: '/manageHsncode',
  //   name: 'Manage Hsn Code'
  // },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  // }
];

export const adminRoutes = [
  {
    path: "/userManagement",
    name: "User Management",
  },
  // {
  //   path:'/manageModule',
  //   name:'Manage Modules'
  // },
  // {
  //   path: '/logout',
  //   name: 'Logout',
  // }
];

export const B2CRoutes = [
  {
    path: "/b2c/upload",
    name: "B2C Data Upload",
  },

  {
    path: "/b2c/invoices",
    name: "B2C Invoices",
  },
];

export const IMSRoutes = [
  {
    path: "/ims/prepare",
    name: "Prepare",
  },
  {
    path: "/ims/save",
    name: "Save",
  },
]

export const HelpAndSupport = [
  {
    path: "/gtaxpro_help_support",
    name: "Help & Support",
  },
]

		export const gstr9NewRoutes = [
  {
    path: "/gstr9_new/upload",
    name: "Data Upload",
  },

  {
    path: "/gstr9_new/fetch_recocile",
    name: "Fetch & Reconcile",
  },
  {
    path: "/gstr9_new/view_prepare",
    name: "View & Prepare",
  },
  {
    path: "/gstr9_new/save",
    name: "Save",
  },
  {
    path: "/gstr9_new/file",
    name: "File",
  }
  // {
  //   path: "/gstr9/saveGstr9",
  //   name: "Save GSTR-9",
  // },
];


export const gstr9CNewRoutes = [
  {
    path: "/gstr9c_new/fetch",
    // path:'/gstr9/saveGstr9',
    name: "Fetch",
  },
  {
    path: "/gstr9c_new/prepare",
    name: "Prepare",
  },
  {
    path: "/gstr9c_new/save",
    name: "Save",
  },
  {
    path: "/gstr9c_new/file",
    name: "File",
  },
]
export const ImsRecoRoutes = [
  {
    path: "#",
    name: "Inward",
    activeList: [
      "/imsreco/dataUpload",
      "/imsreco/view",
      "/imsreco/fetch",
      "/imsreco/reco",
      "/imsreco/save",
    ],
    subRoutes: [
      {
        path: "/imsreco/dataUpload",
        name: "Data Upload",
      },
      {
        path: "/imsreco/view",
        name: "View",
      },
      {
        path: "/imsreco/fetch",
        name: "Fetch",
      },
      {
        path: "/imsreco/reco",
        name: "Reconciliation",
      },
      {
        path: "/imsreco/save",
        name: "Save",
      },
    ],
  },
  {
    path: "/imsreco/outward",
    name: "Outward",
  },
  // {
  //   path: "/imsReco/dataUpload",
  //   name: "Data Upload",
  // },
  // {
  //   path: "/imsReco/fetch",
  //   name: "Fetch",
  // },
  //  {
  //   path: "/imsReco/reco",
  //   name: "Reconciliation",
  // },
  //  {
  //   path: "/imsReco/save",
  //   name: "Save",
  // },
  //  {
  //   path: "/imsReco/outward",
  //   name: "Outward",
  // },
];

export const gstr2a2bNewRoutes = [
  {
    path: "/gstr2a2b/upload",
    name: "Data Upload",
  },
  {
    path: "/gstr2a2b/view",
    name: "View",
  },
  {
    path: "/gstr2a2b/fetch",
    name: "Fetch",
  },
  {
    path: "/gstr2a2b/reconciliation",
    name: "Reconciliation",
  },
 
  {
    path: "/gstr2a2b/itcregister",
    name: "ITC Register",
  },

]
export const noteRoutes = [
   {
    path: "/repository",
    name: "Repository",
  },
]

export const noticeRoute = [
  {
    path: "/notice/notice",
    name: "Notice",
  },
 {
    path: "/notice/emailMaster",
    name: "Email Master",
  },
  {
    path: "/notice/email",
    name: "Email Configuration",
  },

];

export const externalLinks = [
  {
    path: "/external_links",
    name: "Knowledge Hub",
  },
]

export const templateMapping = [
  {
    path: "/template_mapping",
    name: "Template Mapping",
  },
]

export const chatBotRoutes = [
  {
    path: "/chat_bot",
    name: "GTaxPro Assistant",
  },
  // {
  //   path: "/chat_bot/:parentId",
  //   name: "Chat Bot",
  // }
]

export const chatBot =[
  {
    path: "/chat_bot",
    name: "Chat Bot",
  },
  {
    path: "/chat_bot/:parentId",
    name: "Chat Bot",
  },
]